import {useEffect, useRef, useState} from 'react'
import {useAppDispatch} from '../../../../redux/hooks'
import Loader from 'app/custom/loader/Loader'
import {StudentCard} from '../../../../redux/Slice/studentSlice'

const MyCard = () => {
  const [loader, setLoader] = useState(true)
  const dispatch = useAppDispatch()
  const [htmlContent, setHtmlContent] = useState<string | null>(null)
  const cardRef = useRef(null)

  useEffect(() => {
    dispatch(StudentCard()).then((res: any) => {
      if (res.meta.requestStatus === 'fulfilled') {
        setHtmlContent(res.payload)
        setLoader(false)
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {!loader && (
        <div className='row col-12 mb-5 shadow-sm m-1 p-5 mt-0'>
          <div>
            {htmlContent && (
              <iframe
                ref={cardRef}
                title='Student Card Preview'
                srcDoc={htmlContent}
                style={{
                  width: '85.6mm',
                  height: '55mm',
                  border: 'none',
                  borderRadius: '8px',
                  boxShadow: '0 0 8px rgba(0,0,0,0.2)',
                  display: 'block',
                  margin: '0 auto',
                }}
              />
            )}
          </div>
        </div>
      )}
      {loader && <Loader />}
    </>
  )
}

export default MyCard
